import React, {useState} from 'react';
import ParentForm from "../Parent/ParentForm";
import {gql, useMutation, useQuery} from "@apollo/client";
import {Skeleton} from 'antd';
import {useNavigate, useParams} from 'react-router-dom';
import {child_info} from "../../../routes";
import CrmCenteredTitle from "../../../components/CrmCenteredTitle";
import CrmLayout from "../../../components/CrmLayout";
import _ from "lodash";

const QUERY = gql`
    query query (
        $id: ID,
    ) {
        client(id: $id) {
            data {
                id
                attributes {
                    firstName
                    lastName
                    birthDate
                    enabled
                    account {
                        data {
                            id
                            attributes {
                                email
                                blocked
                                contacts {
                                    type
                                    value
                                    data
                                }
                            }
                        }
                    }
                    gym {
                        data {
                            id
                        }
                    }
                }
            }
        }
    }
`;

const UPDDATE_USER = gql`
    mutation users ($id: ID!, $data: UsersPermissionsUserInput!) {
        updateUsersPermissionsUser (id: $id, data: $data) {
            data {
                id
            }
        }
    }
`;

const UPDATE_CHILD = gql`
    mutation users ($id: ID!, $data: ClientInput!) {
        updateClient (id: $id, data: $data) {
            data {
                id
            }
        }
    }
`;

export default function ChildEdit() {

    const {id} = useParams();

    const [loading, setLoading] = useState(false);
    const [accountId, setAccountId] = useState(null);
    const [data, setData] = useState(null);

    const query = useQuery(QUERY, {
        variables: {id: id,},
        onCompleted: ((data) => {
            setData({
                firstName: data.client.data.attributes.firstName,
                lastName: data.client.data.attributes.lastName,
                birthDate: data.client.data.attributes.birthDate,
                contacts: data.client.data.attributes.account.data.attributes.contacts,
                gym: data.client.data.attributes.gym.data &&    data.client.data.attributes.gym.data.id,
            });
            setAccountId(data.client.data.attributes.account.data.id);
        })
    });

    const [updateUser] = useMutation(UPDDATE_USER);
    const [updateChild] = useMutation(UPDATE_CHILD);

    const navigate = useNavigate();

    const onSubmit = async (data) => {
        setLoading(true);
        const userData = {
            firstName: data.firstName,
            lastName: data.lastName,
            contacts: _.map(data.contacts, item => {
                return {
                    ...item,
                    data: item.data && JSON.parse(item.data),
                }
            }),
        }
        await updateUser({variables: {id: accountId, data: userData}});

        const childData = {
            firstName: data.firstName,
            lastName: data.lastName,
            birthDate: data.birthDate,
            gym: data.gym,
        }
        await updateChild({variables: {id: id, data: childData}});

        navigate(child_info(id));

    }

    return (
        <CrmLayout>

            <CrmCenteredTitle
                title={query.data ? `${query.data.client.data.attributes.firstName} ${query.data.client.data.attributes.lastName}` : '—'}
            />

            {query.loading && <Skeleton active/>}

            {query.data &&
            <>
                <ParentForm onSubmit={onSubmit} loading={loading} data={{
                    firstName: query.data.client.data.attributes.firstName,
                    lastName: query.data.client.data.attributes.lastName,
                    birthDate: query.data.client.data.attributes.birthDate,
                    contacts: query.data.client.data.attributes.account.data.attributes.contacts.map(function (value) {
                        return {type: value.type, value: value.value, data: JSON.stringify(value.data)}
                    }),
                    gym: query.data.client.data.attributes.gym.data && query.data.client.data.attributes.gym.data.id,
                }} actionName={'Сохранить'} withGym/>

            </>
            }

        </CrmLayout>
    );
}
